import { render, staticRenderFns } from "./addInstock.vue?vue&type=template&id=11db5c29&scoped=true&"
import script from "./addInstock.vue?vue&type=script&lang=js&"
export * from "./addInstock.vue?vue&type=script&lang=js&"
import style0 from "./addInstock.vue?vue&type=style&index=0&id=11db5c29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11db5c29",
  null
  
)

export default component.exports